import React from "react";

import { ConfigType, WidgetDrawerProps } from "../../../types/widgets";
import { ShippingProgressBarWidgetVariableSettings } from "../DiscountProgressBarWidgetsTab/ShippingProgressBarWidgetVariableSettings";

type VariableSettingsProps = WidgetDrawerProps & { configType: ConfigType };
export const VariableSettings = ({
  widgetType,
  configType,
}: VariableSettingsProps) => {
  if (widgetType === "quantityButtons") {
    return null;
  }

  if (widgetType === "discountProgressBar") {
    return null;
  }

  if (widgetType === "shippingProgressBar") {
    return (
      <ShippingProgressBarWidgetVariableSettings configType={configType} />
    );
  }

  if (widgetType === "messageBoxPopup") {
    return null;
  }

  if (widgetType === "messageBoxSlideOut") {
    return null;
  }

  return null;
};
